import React, { useState, useEffect } from "react";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const StepHumanCapitalGender = ({ data = {}, onSubmit, onBack, saving }) => {
  const [total_employees, setTotalEmployees] = useState(null);
  const [women, setWomen] = useState(null);
  const [men, setMen] = useState(null);
  const [other_gender, setOtherGender] = useState(null);

  useEffect(() => {
    setTotalEmployees(data.total_employees ?? null);
    setWomen(data.women ?? null);
    setMen(data.men ?? null);
    setOtherGender(data.other_gender ?? null);
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      total_employees: total_employees ?? null,
      women: women ?? null,
      men: men ?? null,
      other_gender: other_gender ?? null,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep4Title") || "Capitale Umano Sesso"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep4Description") ||
            "Raccontaci di quanti collaboratori dispone la tua azienda e delle loro competenze, così da valorizzare il tuo capitale umano."}
        </p>
      </div>
      <div className="p-fluid grid">
        <div className="col-12 md:col-6">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep4LabelTotalEmployees") || "Nr. TOTALE DI DIPENDENTI"}
          </label>
          <InputNumber
            value={total_employees}
            onValueChange={(e) => setTotalEmployees(e.value)}
            className="w-full border-round-md p-no-outline"
            min={0}
            useGrouping={false}
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep4LabelWomen") || "Donne"}
          </label>
          <InputNumber
            value={women}
            onValueChange={(e) => setWomen(e.value)}
            className="w-full border-round-md p-no-outline"
            min={0}
            useGrouping={false}
          />
          <small className="text-color-secondary">
            {localeText("businessDiagnosisStep4GenderDistributionHelp") ||
              "Distribuzione di genere."}
          </small>
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep4LabelMen") || "Uomini"}
          </label>
          <InputNumber
            value={men}
            onValueChange={(e) => setMen(e.value)}
            className="w-full border-round-md p-no-outline"
            min={0}
            useGrouping={false}
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep4LabelOtherGender") || "Altro sesso"}
          </label>
          <InputNumber
            value={other_gender}
            onValueChange={(e) => setOtherGender(e.value)}
            className="w-full border-round-md p-no-outline"
            min={0}
            useGrouping={false}
          />
        </div>
      </div>
      <div className="flex gap-2 flex-wrap mt-2 justify-content-end">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            onClick={onBack}
            disabled={saving}
            style={{ color: "var(--theme-primary)" }}
          />
        )}
        <Button
          type="submit"
          loading={saving}
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepHumanCapitalGender;
